import React, { useContext } from 'react';
import { StyleSheet, View } from 'react-native';
import { useTheme } from '@rneui/themed';
import FontAwesome6 from '@expo/vector-icons/FontAwesome6';
import PropTypes from 'prop-types';
import { SupportedSocialPlatforms } from '../SocialLink';
import IconButton from '../../common/IconButton';
import { H6 } from '../../text';
import LayoutContext from '../../../contexts/Layout';

const Icon = ({ color, name, size, style }) => <FontAwesome6 name={name} size={size} color={color} style={style} />;

export const ThePost = ({ caption, postTimeStamp, nodeTypeAlias = 'SocialPostContainer.ThePost', socialHandle, type, width }) => {
    const { layout } = useContext(LayoutContext);
    const { theme } = useTheme();
    let backgroundColor;

    if (type.equals(SupportedSocialPlatforms.FACEBOOK)) {
        backgroundColor = theme.colors.facebook;
    } else if (type.equals(SupportedSocialPlatforms.YOUTUBE)) {
        backgroundColor = theme.colors.youtube;
    } else if (type.equals(SupportedSocialPlatforms.INSTAGRAM)) {
        backgroundColor = theme.colors.instagram;
    } else if (type.equals(SupportedSocialPlatforms.XTWITTER)) {
        backgroundColor = theme.colors.twitter;
    }

    return (
        <View
            style={{ marginBottom: layout.styleGuide.componentSeparator, width }}
            dataSet={{
                umbracoComponentName: nodeTypeAlias,
                spacerBottom: `StyleGuide.ComponentSeparator(${layout.styleGuide.componentSeparator})`,
                spacerLeft: `StyleGuide.Spacer1(${layout.styleGuide.spacer1})`,
                spacerRight: `StyleGuide.Spacer1(${layout.styleGuide.spacer1})`
            }}
        >
            <View
                style={StyleSheet.flatten(Styles.container, {
                    backgroundColor: backgroundColor,
                    paddingHorizontal: Math.floor(layout.styleGuide.spacer1 + layout.styleGuide.spacer5 * 2),
                    paddingVertical: Math.floor(layout.styleGuide.spacer5 * 2)
                })}
            >
                <View style={Styles.iconWrapper}>
                    <IconButton icon={<Icon color='#fff' name={type} size={48} />} size={48} style={{ borderWidth: 0 }} />
                </View>
                <View style={{ justifyContent: 'center', alignItems: 'center' }}>
                    <H6
                        numberOfLines={20}
                        style={{ color: '#fff', marginVertical: layout.styleGuide.spacer2 }}
                        dataSet={{ spacerBottom: `StyleGuide.Spacer2(${layout.styleGuide.spacer2})`, spacerTop: `StyleGuide.Spacer2(${layout.styleGuide.spacer2})` }}
                        text={caption}
                    />
                    <H6 text={`${socialHandle} - ${postTimeStamp}`} style={{ color: '#fff' }} />
                </View>
            </View>
        </View>
    );
};

const Styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 300
    },
    iconWrapper: {
        flexDirection: 'row',
        justifyContent: 'center'
    }
});

ThePost.propTypes = {
    caption: PropTypes.string,
    icon: PropTypes.object,
    postTimeStamp: PropTypes.string,
    socialHandle: PropTypes.string,
    type: PropTypes.string
};
